import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Loading } from "../../ui";
import { BundleService } from "../bundle/BundleService";
import { Bundle } from "./Bundle";

interface IProps {
	handleChange: (selectedBundles: any[], actionType: any) => any;
	value?: any;
	defaultValue?: any;
	bundles?: Bundle[];
}

export const BundleSelect = (props: IProps): ReactElement => {
	const [bundles, setBundles] = useState<Bundle[]>();

	const bundleService = new BundleService();

	useMemo(() => {
		if (!props.bundles) {
			const fetchBundles = async () => {
				const bundleData = await bundleService.findAll();
				setBundles(bundleData);
			};

			fetchBundles();
		} else {
			setBundles(props.bundles);
		}
	}, []);

	if (!bundles) {
		return <Loading />;
	}

	const options = bundles.map((bundle: Bundle) => {
		return {
			value: bundle.id,
			label: bundle.name,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			isMulti={true}
			isClearable={false}
			onChange={(selectedBundles: any, actionType: any) => {
				if (!selectedBundles) {
					selectedBundles = [];
				}
				const keys = selectedBundles.map((selectedItem: any) => {
					return selectedItem.value;
				});

				const filteredBundles = _.filter(bundles, bundle => {
					return _.indexOf(keys, bundle.id) !== -1;
				});

				props.handleChange(filteredBundles, actionType);
			}}
		/>
	);
};
